import { notification } from 'ant-design-vue'

notification.config({
  placement: 'topRight',
  top: 70,
  duration: 5,
  maxCount: 3,
  closeIcon: h => h('a-icon', { props: { type: 'close' } })
})

const notificationAlert = (message, type = undefined) => {
  const status = message.response ? message.response.status : message.status
  if ((type !== undefined && status !== undefined) || status === 200) {
    notification.success({ message: message.data.message })
  } else {
    if (status < 199) {
      notification.info({ message: message.response.data.message })
    }
    if (status < 499) {
      notification.warning({ message: message.response.data.message })
    } else if (status < 599) {
      notification.error({ message: message.response.data.message })
    }
  }
}

export default notificationAlert
